export function removeUndefinedEntriesFromObject(obj: { [key: string]: any }) {
  return Object.keys(obj).reduce((acc, curr) => {
    return {
      ...acc,
      ...(![undefined, '', null].includes(obj[curr]) && {
        [curr]: obj[curr],
      }),
    };
  }, {});
}
